export const REVIEW_HOTEL = "Review hotel";
export const REVIEW_FLIGHT = "Review flight";
export const CONTINUE_TO_CHECKOUT = "Continue to checkout";
export const CONTINUE_TO_CHECKOUT_LOADING = "Loading...";
export const REVIEW_PACKAGE_DETAILS = "Review package details";
export const REVIEW_HOTEL_AND_FLIGHT = "Review your hotel and flight package";
